module.exports = __webpack_public_path__ + "img/paquetes-barcelo.edb03832.jpg";